import { useLazyQuery as i } from "@apollo/client";
import { ERROR_CODE as m, ERROR_MESSAGES as f } from "../../constants/error.js";
import { useMessageContext as p } from "../../contexts/share/MessageContext.js";
import { accountSchema as l } from "../../deserialize/yup/account.js";
import { deserializeData as R } from "../../graphql/deserialize/index.js";
import h from "../../graphql/query/getAccountDetail.js";
import { getAccessToken as d, getRefreshToken as E } from "../../util/authenication/index.js";
import * as e from "ramda";
import { useState as O, useCallback as C } from "react";
const x = () => {
  const { showGeneralError: o } = p(), [t, { loading: a }] = i(h), [c, n] = O(null);
  return {
    fetch: C(async () => {
      const r = await t(), u = e.pipe(
        e.assocPath(["data", "accessToken"], d()),
        e.assocPath(["data", "refreshToken"], E())
      );
      e.pathOr(
        null,
        ["error", "cause", "result", "errors", 0, "extensions", "subCode"],
        r
      ) === m.GRAPHQL.FORCE_LOGOUT && o(f.JWT_ERROR);
      const s = R(
        u(r),
        l
      );
      return n(s), s;
    }, [t, o]),
    data: c,
    loading: a
  };
};
export {
  x as default
};
//# sourceMappingURL=useGetAccountDetail.js.map
